import React from 'react'
import { connect } from 'react-redux'
import { getTransactionTrackerData } from '../../../store/Procurement/actionCreator'
import MrtReusableTable from '../../Utils/MrtReusableTable'
import { handleFireflySendEvent } from '../../Utils/FireFlyVnextHelpers'

export class transactionTrackerTab extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      transactionTrackerList: [],
      loading: true,
    }
    this.baseState = { ...this.state }
  }

  async componentDidMount() {
    this.setState({ loading: true })
    await this.props.getTransactionTrackerData()
    this.setState({
      transactionTrackerList: this.props.transactionTrackerList,
      loading: false,
    })
    const { userInfo } = this.props
    if (userInfo.email !== '') {
      handleFireflySendEvent(
        'PAGE_VIEW',
        'R&D PIN Transactions',
        'R&D PIN Transactions Tab Load',
        userInfo,
      )
    }
  }

  static defaultProps = {
    userInfo: {
      email: undefined,
    },
  }

  render() {
    const columns = [
      { header: 'Date', accessorKey: 'date' },
      {
        header: 'Type of Transaction',
        accessorKey: 'type_of_transaction',
      },
      {
        header: 'Transaction Number',
        accessorKey: 'transaction_number',
      },
      {
        header: 'Billing R&D PIN',
        accessorKey: 'billing_rd_pin',
      },
      { header: 'Site', accessorKey: 'site' },
      { header: 'Qty', accessorKey: 'qty' },
      {
        header: 'Manufacturer',
        accessorKey: 'manufacturer',
      },
      { header: 'UPN', accessorKey: 'upn' },
      {
        header: 'Description',
        accessorKey: 'description',
      },
      {
        header: 'Inventory R&D PIN',
        accessorKey: 'inventory_rd_pin',
      },
      {
        header: 'Warehouse',
        accessorKey: 'warehouse',
      },
      {
        header: 'Notes',
        accessorKey: 'notes',
      },
    ]

    const defaultColumns = [
      'date',
      'type_of_transaction',
      'transaction_number',
      'billing_rd_pin',
      'site',
      'qty',
      'upn',
      'inventory_rd_pin',
      'warehouse',
      'notes',
    ]

    return (
      <MrtReusableTable
        pageSize={[100, 200, 500]}
        pageTitle={'R&D Pin Transactions'}
        columns={columns}
        rowData={this.state.transactionTrackerList}
        defaultColumns={defaultColumns}
        loading={this.state.loading}
        loadingMessage="R&D Pin Transactions Loading..."
      />
    )
  }
}

const mapStateToProps = (state) => ({
  transactionTrackerList: state.procurement.transactionTrackerList || [],
  userInfo: state.auth.userInfo,
})

const mapDispatchToProps = {
  getTransactionTrackerData,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(transactionTrackerTab)
